import { motion } from 'framer-motion';

export default function ConsultingSection() {
  const services = [
    {
      icon: 'ri-file-list-3-line',
      title: '안전관리계획서',
      law: '건진법 제62조',
      targets: [
        '1종, 2종 시설물',
        '지하 10M 이상 굴착',
        '10층~15층 건축물 건설',
        '타워크레인 사용공사',
      ],
    },
    {
      icon: 'ri-alert-line',
      title: '유해위험방지계획서',
      law: '산안법 제42조',
      targets: [
        '지상높이 31M 이상 건축물',
        '연면적 3만㎡ 이상 건축물',
        '깊이 10M 이상 굴착공사',
        '냉동·냉장창고 설비공사',
      ],
    },
    {
      icon: 'ri-search-eye-line',
      title: '설계안전성 검토(D.F.S)',
      law: '건진법',
      targets: [
        '안전관리계획서 작성대상과 동일',
        '1종, 2종 시설물',
        '지하 10M 이상 굴착',
        '천공기, 항타 및 항발기 사용',
      ],
    },
    {
      icon: 'ri-book-open-line',
      title: '안전보건대장 작성/확인',
      law: '50억 이상',
      targets: [
        '기본 안전보건대장 (발주자)',
        '설계 안전보건대장 (설계자)',
        '공사 안전보건대장 (시공자)',
        '이행확인 점검 (3개월마다)',
      ],
    },
    {
      icon: 'ri-team-line',
      title: '안전보건조정자',
      law: '50억 이상',
      targets: [
        '2개 이상 건설공사 혼재',
        '분리발주 선임여부 검토',
        '혼재작업 조정 역할',
        '활동일지 작성',
      ],
    },
    {
      icon: 'ri-shield-check-line',
      title: '안전보건관리체계 구축',
      law: '중대재해처벌법',
      targets: [
        '중대재해처벌법 대비',
        '안전보건관리 체계 메뉴얼 작성',
        '중대재해처벌법 및 메뉴얼 교육',
      ],
    },
  ];

  return (
    <section id="consulting" className="py-16 sm:py-24 lg:py-32 bg-[#1a2b4a]">
      <div className="max-w-[1400px] mx-auto px-4 sm:px-6">
        {/* Section Header */}
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="text-center mb-10 sm:mb-16"
        >
          <div className="text-[#ff6b35] text-xs font-semibold tracking-[0.2em] mb-2 sm:mb-3">
            CONSULTING FIELD
          </div>
          <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold text-white mb-3 sm:mb-4">
            컨설팅 분야
          </h2>
          <p className="text-sm sm:text-lg text-white/80">
            전문적이고 체계적인 건설안전 컨설팅 서비스
          </p>
        </motion.div>

        {/* Service Cards Grid */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 sm:gap-6 lg:gap-8 mb-10 sm:mb-16">
          {services.map((service, index) => (
            <motion.div
              key={index}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.6, delay: index * 0.1 }}
              whileHover={{ y: -5 }}
              className="bg-white/10 backdrop-blur-sm border border-white/30 rounded-xl sm:rounded-2xl p-5 sm:p-8 hover:bg-white/15 transition-all duration-300 cursor-pointer"
            >
              {/* Icon */}
              <div className="w-12 h-12 sm:w-16 sm:h-16 bg-[#ff6b35] rounded-full flex items-center justify-center mb-4 sm:mb-6">
                <i className={`${service.icon} text-white text-xl sm:text-2xl`}></i>
              </div>

              {/* Title */}
              <h3 className="text-lg sm:text-xl lg:text-2xl font-bold text-white mb-1 sm:mb-2">
                {service.title}
              </h3>
              <div className="text-xs sm:text-sm text-[#ff6b35] font-medium mb-3 sm:mb-5">
                {service.law}
              </div>

              {/* Divider */}
              <div className="border-t border-white/20 mb-3 sm:mb-5"></div>

              {/* Targets */}
              <ul className="space-y-2 sm:space-y-3 mb-4 sm:mb-6">
                {service.targets.map((target, idx) => (
                  <li
                    key={idx}
                    className="flex items-start gap-2 text-xs sm:text-sm text-white/90"
                  >
                    <span className="text-[#ff6b35] mt-0.5">▪</span>
                    <span>{target}</span>
                  </li>
                ))}
              </ul>

              {/* Link */}
              <a
                href="#"
                className="inline-flex items-center gap-2 text-xs sm:text-sm text-[#ff6b35] hover:gap-3 transition-all whitespace-nowrap"
              >
                자세히 보기
                <i className="ri-arrow-right-line"></i>
              </a>
            </motion.div>
          ))}
        </div>

        {/* CTA */}
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="text-center"
        >
          <p className="text-lg sm:text-2xl text-white mb-4 sm:mb-6">
            전문 컨설팅이 필요하신가요?
          </p>
          <button className="px-8 sm:px-12 py-3 sm:py-4 bg-[#ff6b35] text-white text-sm sm:text-lg font-semibold rounded-full hover:bg-[#ff5722] transition-all hover:shadow-2xl whitespace-nowrap">
            지금 바로 상담 신청하세요
          </button>
        </motion.div>
      </div>
    </section>
  );
}
